
const CloseCircleIcon = ({
  size = 12,
  color = "#BC6B38", // circle color
  crossColor = "white", // X color
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <circle cx="6" cy="6" r="6" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.21653 4.21653C4.33857 4.09449 4.53643 4.09449 4.65847 4.21653L6 5.55806L7.34153 4.21653C7.46357 4.09449 7.66143 4.09449 7.78347 4.21653C7.90551 4.33857 7.90551 4.53643 7.78347 4.65847L6.44194 6L7.78347 7.34153C7.90551 7.46357 7.90551 7.66143 7.78347 7.78347C7.66143 7.90551 7.46357 7.90551 7.34153 7.78347L6 6.44194L4.65847 7.78347C4.53643 7.90551 4.33857 7.90551 4.21653 7.78347C4.09449 7.66143 4.09449 7.46357 4.21653 7.34153L5.55806 6L4.21653 4.65847C4.09449 4.53643 4.09449 4.33857 4.21653 4.21653Z"
        fill={crossColor}
      />
    </svg>
  );
};

export default CloseCircleIcon;
